import { render, staticRenderFns } from "./SwisstexIVA.vue?vue&type=template&id=abaf531c&scoped=true&"
import script from "./SwisstexIVA.vue?vue&type=script&lang=js&"
export * from "./SwisstexIVA.vue?vue&type=script&lang=js&"
import style0 from "./SwisstexIVA.vue?vue&type=style&index=0&id=abaf531c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abaf531c",
  null
  
)

export default component.exports